import { Chart, ChartOptions, Plugin } from 'chart.js';
import { DIAGRAM_COLORS, AXIS_IDS } from '../constants';

const { white, transparentWhite } = DIAGRAM_COLORS;
const siemensFontFamily = 'SiemensSans';

export const BACKGROUND_COLOR_PLUGIN: Plugin = {
    id: 'custom_canvas_background_color',
    beforeDraw: (chart: Chart) => {
        const { ctx, chartArea: { top, right, bottom, left } } = chart;
        ctx.save();
        ctx.fillStyle = '#333353';
        ctx.fillRect(left, top, right - left, bottom - top);
        ctx.restore();
    }
};

export const DEFAULT_DIAGRAM_OPTIONS: ChartOptions = {   
    responsive: true,
    maintainAspectRatio: true,
    hover: {
        mode: 'index',
        intersect: true
    },
    animation: {
        duration: 0
    },
    elements: {
        line: {
            cubicInterpolationMode: 'monotone'
        }
    },
    plugins: {
        legend: {
            display: false
        },
        tooltip: {
            enabled: true,
            mode: 'index',
            intersect: true
        },
        zoom: {
            limits: {
                x: { min: 0, max: undefined },
                y: { min: undefined, max: undefined }
            },
            pan: {
                enabled: false,
                mode: 'x',
                threshold: 10              
            },
            zoom: {
                drag: {
                    enabled: true,
                    threshold: 2
                },
                mode: 'x',
                wheel: {                    
                    speed: 0.1                    
                }                
            }
        }
    },
    scales: {
        [AXIS_IDS.xAxis0]: {
                type: 'linear',
                display: true,
                min: 0,
                title: {
                    display: true,
                    text: '',
                    color: white,
                    font: {
                        family: siemensFontFamily,
                        size: 14
                    }
                },
                ticks: {
                    autoSkip: true,
                    minRotation: 0,
                    maxRotation: 0,
                    padding: 10,
                    font: {
                        size: 14,
                        family: siemensFontFamily
                    },
                    color: white
                },
                grid: {
                    color: white,
                    lineWidth: ctx => ctx.index === 0 ? 2 : 0,
                    drawTicks: false
                }
        },
        [AXIS_IDS.yAxis0]: {
            position: 'left',
            display: true,
            min: 0,
            title: {
                display: true,
                text: '',
                color: white,
                font: {
                    family: siemensFontFamily,
                    size: 14
                }
            },
            ticks: {
                padding: 10,
                font: {
                    size: 14,
                    family: siemensFontFamily
                },
                color: white
            },
            grid: {
                color: ctx => ctx.index === 0 ? white : transparentWhite,
                lineWidth: ctx => ctx.index === 0 ? 2 : 1,
                drawTicks: false
            }
        }
    }
};
